module.exports = __webpack_public_path__ + "static/media/mars-awakens-4.9bab76c9.jpg";